import  { useState, useEffect } from "react";
import {  Button, Card, Row, Col, Skeleton, message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Footer } from "./footer";
import { API_ENDPOINTS ,formatBlogContent } from "./config";
import "./Blog.css";

const { Meta } = Card;

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.LIST_BLOGS);
        if (Array.isArray(response.data)) {
          setBlogs(response.data);
        } else {
          message.warning("No blogs found");
          setBlogs([]);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
        message.error("Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleReadMore = (post) => {
    navigate(`/blog/${post.id}`);
  };


  const truncateContent = (content, maxLength = 100) => {
    if (!content) return "";
    const strippedContent = content.replace(/<[^>]*>/g, "");
    return strippedContent.length <= maxLength
      ? strippedContent
      : `${strippedContent.substr(0, maxLength)}...`;
  };


  if (loading) {
    return (
      <div className="blog-container">
        <Row gutter={[24, 24]} style={{ padding: "24px" }}>
          {[1, 2, 3].map((item) => (
            <Col xs={24} sm={12} lg={8} key={item}>
              <Card>
                <Skeleton active />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  }

  return (
    <div className="blog-container2">
      <div className="blog-container">
        <div className="blog-header">
          <h1>Our Latest Blogs</h1>
        </div>

        <Row gutter={[24, 24]} className="blog-grid">
          {blogs.map((post) => (
            <Col xs={24} sm={12} lg={8} key={post.id}>
              <Card
                hoverable
                className="blog-card"
                cover={
                  <div
                    className="blog-image"
                    style={{ backgroundImage: `url(${post.blog_image})` }}
                    onClick={() => handleReadMore(post)}
                  />
                }
              >
                <Meta
                  title={formatBlogContent(post.blog_name)}
                  description={truncateContent(formatBlogContent(post.blog_content_english))}
                />
                <div className="blog-footer">
                  <Button
                    type="link"
                    onClick={() => handleReadMore(post)}
                    className="read-more-btn"
                  >
                    Read More →
                  </Button>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
      <Footer />

    </div>
  );
};

export default Blog;